import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ContainerBox = styled(Box)(({ theme }) => ({
    margin:'0 10%',
    background: '#FFF',
    padding:'3rem 1.5rem',
}));

export default ContainerBox;